import React, { useState } from "react";
import { AppBar, Toolbar, IconButton, Menu, MenuItem } from "@material-ui/core";
import { Menu as MenuIcon, Person as AccountIcon, ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import classNames from "classnames";
// styles
import useStyles from "./styles";

// components
import { Typography } from "../Wrappers";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../Context/LayoutContext";
import { useUserDispatch, signOut } from "../../Context/UserContext";
import logoEqut from './logoequt.png'

export default function Header(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [profileMenu, setProfileMenu] = useState(null);

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButtonSandwich,
            classes.headerMenuButtonCollapse,
          )}
        >
          {layoutState.isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton>
        <img
          src={logoEqut}
          alt="Equativ Logo"
          style={{height:28}}
        />


        <div className={classes.grow} />


        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={e => setProfileMenu(e.currentTarget)}
        >
          {(() => {
        if (localStorage.getItem("imageUrl")) {
          return (
            
            <img
              src={localStorage.getItem("imageUrl")}
              alt="User avatar"
              style={{ width: "45px", height: "45px", borderRadius: "50px" }}
            />
            )
          } 
        })()}
                  {(() => {
        if (!localStorage.getItem("imageUrl")) {
          document.cookie = "Logincookie; expires=" + new Date(0).toUTCString();
          localStorage.removeItem('email');
          localStorage.removeItem('imageUrl');
          localStorage.removeItem('name');
          //signOut(userDispatch, props.history);
          return (
            <AccountIcon classes={{ root: classes.headerIcon }} />
            )
          } 
        })()}

         
        </IconButton>
        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          
          <div className={classes.profileMenuUser}>
          {(() => {
        if (localStorage.getItem("name")) {
          return (
            <Typography
            className={classes.profileMenuLink}
            color="black"
          >
            Hello, {localStorage.getItem("name")}
          </Typography>
            )
          } 
        })()}
            <Typography
              className={classes.profileMenuLink}
              color="primary"
              onClick={() => {signOut(userDispatch, props.history);document.cookie = "Logincookie; expires=" + new Date(0).toUTCString();}}
            ><br></br>
              Log out
            </Typography>
          </div>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
